module.exports = __webpack_public_path__ + "img/WP23-Indaba1.bc9ff8ba.jpg";